export default (el, { expression }, { evaluate, cleanup }) => {
    const detail = evaluate(expression)
    const id = Math.random().toString(16).slice(2)
    el.setAttribute('id', id)

    const confirmed = () => evaluate(el.getAttribute('confirmed'))
    window.addEventListener('confirmed-' + id, confirmed)

    if(el.getAttribute('canceled'))
    {
        const canceled = () => evaluate(el.getAttribute('canceled'))
        window.addEventListener('canceled-' + id, canceled)
    }

    cleanup(() => {
        window.removeEventListener('confirmed-' + id, confirmed)
        window.removeEventListener('canceled-' + id, confirmed)
    })

    el.addEventListener('click', (event) => {
        window.dispatchEvent(new CustomEvent('confirm', {
            detail: {
                ...detail,
                id: id
            }
        }));

        event.stopPropagation();
    })
}
